import React from 'react';
import { Grid, Box } from '@mui/material';

import useWindowSize from '@shared/hooks/useWindowsSize';
import { convertToCamelCase } from '@shared/helpers';

import FilterTitle from './FilterTitle';
import PriceFilter from './PriceFilter';
import RegimenFilter from './RegimenFilter';
import OrderBySelect from './OrderBySelect';
import ActionButtons from './ActionButtons';

import useHotelFiltersState from '@HotelSearchHooks/useHotelFiltersState';

const HotelFiltersContent = ({
  hotelSearchResults,
  filter,
  setFilter,
  handelFilterAplicated,
  priceRange,
  setPriceRange,
  pricesFiltered,
  setPricesFiltered,
  handleClose,
  totalNights,
  orderHotelsBy,
  handleSetOrderHotelsBy,
  handleClearFilterAplicated,
}) => {
  const screenWidth = useWindowSize().width;

  const {
    availableRegimens,
    currentSelectedRegimen,
    calculatedMinPrice,
    calculatedMaxPrice,
    userFilteredMinPrice,
    userFilteredMaxPrice,
    setUserFilteredMinPrice,
    setUserFilteredMaxPrice,
    handlePriceInputChange,
    handleRegimenChange,
    applyFilters,
    resetFilters,
  } = useHotelFiltersState({
    hotelSearchResults,
    filter,
    setFilter,
    handelFilterAplicated,
    priceRange,
    setPriceRange,
    pricesFiltered,
    setPricesFiltered,
    handleClose,
    totalNights,
    handleClearFilterAplicated,
  });

  return (
    <Grid
      container
      item
      xs={12}
      sx={{
        p: { xs: 5, sm: 3 },
        width: '100%',
        backgroundColor: '#fff',
        border: { xs: 0, sm: '1px solid #E5E5E5' },
        borderRadius: '8px',
        boxShadow: { xs: 'none', sm: '0px 4px 20px 0px #e3e3e3' },
      }}
    >
      <FilterTitle screenWidth={screenWidth} onClose={handleClose} />

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          mt: 2,
          gap: 3,
          width: '100%',
          flexGrow: 1,
        }}
      >
        <PriceFilter
          fixedPriceMin={calculatedMinPrice}
          filteredPriceMin={userFilteredMinPrice}
          setFilteredPriceMin={setUserFilteredMinPrice}
          fixedPriceMax={calculatedMaxPrice}
          filteredPriceMax={userFilteredMaxPrice}
          setFilteredPriceMax={setUserFilteredMaxPrice}
          handlePriceInputChange={handlePriceInputChange}
        />

        <RegimenFilter
          regimenList={availableRegimens}
          selectedRegimen={currentSelectedRegimen}
          handleRegimenChange={handleRegimenChange}
          convertToCamelCase={convertToCamelCase}
        />

        <OrderBySelect
          orderHotelsBy={orderHotelsBy}
          handleSetOrderHotelsBy={handleSetOrderHotelsBy}
        />

        <ActionButtons
          applyFiltersClick={applyFilters}
          handleClearFilters={resetFilters}
        />
      </Box>
    </Grid>
  );
};

export default HotelFiltersContent;
